import axiosApiInstance from "../app/axios";
import { LPR_SERVER_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const getLprEnquiries = async (page, size, sort, sortBy) =>
  axiosApiInstance.get(`${LPR_SERVER_URL}/lpr/enquiries`, {
    params: { page, size, sort, sortBy },
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });
